<script>
    import { clone, ui, prefs, state, res } from './stores.js';
    import { exportGame, exportUpload, savePrefs } from './save.js';
    import { format } from 'timeago.js';
    import { copySetup} from './bgg.js';
    import { get, set } from 'idb-keyval';
    import { draggable } from 'svelte-drag';
    import Log from './Log.svelte';
    import Track from './Track.svelte';
    import { isMe, numMultiPlayers, sendUpdate} from './net.js';
    import { Tabs, Tab, TabList, TabPanel } from 'svelte-tabs';
    import { allActions } from './card_actions.js';
    import { cleanUp, undo, updateState } from './game.js';
    import { resolveCampaign, takeTurns } from './turns.js';
    import { advance, catchupFully, catchupToChoice, convertChoiceBack, formatBytes, skipIfCan } from './ui.js';
    import { isSuit } from './newcards/types.js';
    import { onDestroy, tick } from 'svelte';
    import { doActionPause } from './parse.js';
    import { bootOff, clearSyncConflict, clearSyncFailed, keepMyState, lastSynced, makeInvite, numSyncsQueued, numSyncsThisSession, reconnectGame, refreshSync, retrySync, sendQueue, togglePublic, useServerState } from './sb.js';
    import { fade } from 'svelte/transition';
    import ModalButton from './ModalButton.svelte';
    import ScoreAnalysis from './ScoreAnalysis.svelte';
    import { allScoreableCards } from './scores.js';
    import { formatPerfReport, resetPerf } from './perf.js';

    let networkGamesChoices = ['Never', 'Multiplayer only', 'Always'];

    export let name;
    let mini = false;
    //let stardateList = $prefs.stardateCards.join(', ');
    let uname = $prefs.username;
    let perfReportText = '';
    console.log(name)
    let dragOptions = {
        axis: 'both'
    };
    if(name == 'Log' || name == 'Options') dragOptions.axis = 'none';

   /* function updateStardate(){
        let list = stardateList.split(',').trim().map(c => parseInt(c));
        if(list.every(l => !isNaN(l))) $prefs.stardateCards = list;
    }*/

    let date = new Date();
    let queue = sendQueue.queued();
    let synced = lastSynced();
    // Was never cleared: one leaked 500ms timer per modal ever opened.
    const clockTimer = setInterval(() => {
        date = new Date();
        if(name == 'Network'){
            queue = sendQueue.queued();
            synced = lastSynced();
        }
    }, 500);
    onDestroy(() => clearInterval(clockTimer));

    function toSetup(){
        if(!confirm('Are you sure you want to abandon game and go back to the setup page?')) return;
        $ui.showingOptions = false;
        $ui.backToSetup();
    }

    function logAll(){
        console.log('state', $state);
        console.log('ui', $ui);
        console.log('prefs', $prefs);
        console.log('res', $res);
    }

    function copyChoices(){
        navigator.clipboard.writeText(JSON.stringify($state.choices.thisTurn));
    }

    function copyNL(){
        let toCopy = ['Current time: '+date.toLocaleTimeString()];
        for(let l of $ui.netLog){
            toCopy.push(`${l.time.toLocaleTimeString()}: ${l.text}`);
        }
        toCopy = toCopy.join('\n');
        navigator.clipboard.writeText(toCopy);
    }

    function formatNL(t){
        let col = 'white';
        if(!t) return '';
        if(t.startsWith('(')) col = 'lightgrey';
        if(t.startsWith('Sent')) col = 'lightgreen';
        if(t.startsWith('Received')) col = 'yellow';
        if(t.startsWith('Error')) col = 'red';
        if(t.startsWith(`Subscribed`)) col = 'orange';
        return `color: ${col};`
    }

    async function loadChoices(){
        let choices = await navigator.clipboard.readText();
        try{
            choices = JSON.parse(choices);
            $ui.loadedChoices = [...choices];
            $ui.showingOptions = false;
            await tick();
            await catchupFully();
        }catch(e){
            alert('Error loading: '+e.message);
            return;
        }
    }

    async function resetAndLoadChoices(){
        let choices = $state.choices.thisTurn;
        $state = clone($res.interimState.state);
        $res.undos = $res.undos.slice(0, $res.interimState.undoLength);
        $res.deltas = $res.deltas.slice(0, $res.interimState.undoLength);
        $ui.loadedChoices = [...choices];
        $ui.showingOptions = false;
        await doActionPause();
        await catchupFully();
    }

    async function catchUpManually(){
        $ui.catchingUp = false;
    }

    function toScoring(){
        if(!confirm('Are you sure you want to end the game early and jump to the scoring page?')) return;
        $ui.showingOptions = false;
        $ui.endGame();
    }

    async function forceUndo(){
        await undo();
        console.log($state, $ui);
        if($state.ended){
            $state.burn = false;
            $state.ended = false;
            $state.startedGameEndActions = false;
            $state.gameEndActionsComplete = false;
            if($state.gameEndTurn == $state.turn) $state.gameEndTurn = -1;
        }
        if($ui.waiting && $ui.waiting.some(w => w.finalMessage)){
            $state.restartTurns = true; 
            await skipIfCan(); // To trigger this
            //takeTurns();
        }
    }

    $: savePrefs($prefs);

    function updateGlory(){
        $state.glory = $prefs.gloryPile;
    }

    function performanceContext(){
        return {
            turn: $state.turn,
            phase: $state.phase,
            step: $state.step,
            currentPlayer: $state.currentPlayer,
            activePlayer: $state.activePlayer,
            logLength: Array.isArray($state.log) ? $state.log.length : 0,
            workingLogLength: Array.isArray($state.workingLog) ? $state.workingLog.length : 0,
            cardLogLength: $state.cardLog ? Object.keys($state.cardLog).length : 0,
            undoSnapshots: $res.prevStates ? $res.prevStates.length : 0,
            undoThreshold: $res.undoThreshold,
            deltas: $res.deltas ? $res.deltas.length : 0,
            undos: $res.undos ? $res.undos.length : 0,
            canSave: $ui.canSave,
            saved: $ui.saved,
            players: ($state.players || []).map(p => ({
                captain: p.captain,
                bot: !!p.bot,
                score: p.score,
                decks: Object.entries(p.decks || {}).reduce((decks, entry) => {
                    let [name, deck] = entry;
                    if(Array.isArray(deck)) decks[name] = deck.length;
                    return decks;
                }, {})
            }))
        };
    }

    async function copyPerformanceReport(){
        if(!$prefs.performanceMeasures){
            alert('Performance measurements are disabled. Enable them first, play a little, then copy the report.');
            return;
        }
        perfReportText = formatPerfReport(performanceContext());
        try{
            await navigator.clipboard.writeText(perfReportText);
            alert('Performance report copied to clipboard.');
        }catch(e){
            alert('Unable to copy automatically; report is shown in the text box.');
        }
    }

    function resetPerformanceReport(){
        resetPerf();
        perfReportText = '';
        alert('Performance data reset.');
    }
</script>
<div class="modal" class:mini={mini} class:working_log={name == 'Log'} style="max-height: 70vh;" > <!--use:draggable={dragOptions}-->
        {#if name == 'Help'}
            <h2>Help</h2>
            To come...

            In the meantime, keyboard shortcuts:
            <h3>Card-specific</h3>
            These take effect when hovering over a card:
            <ul>
            {#each allActions.filter(a => a.hasOwnProperty('cardShortcut') && a.hasOwnProperty('name')) as a}
                <li><b>{a.cardShortcut} – {a.name}</b></li>
            {/each}
            </ul>
            <h4>General</h4>
            <ul>
                <li>up/down – increment/decrement a token or track value</li>
                <li>v – show game log</li>
                <li>? - show help</li>
                <li>Ctrl-Z - undo</li>
                <li>x - close all open deck views (in case something glitches)</li>
                <li>return - click 'OK' or select the default/first option of a choice</li>
            </ul>
        {:else if name == 'Options'}
            <h2>Options</h2>
            <div>
                <Tabs>
                    <TabList>
                        <Tab>Game</Tab>
                        <Tab>Interface</Tab>
                        <!--<Tab>Sounds</Tab>-->
                        <Tab>Automation</Tab>
                        <Tab>Debug</Tab>
                    </TabList>
                <TabPanel>
                    <h2>Game</h2>
                    <div>
                        Copy setup summary to clipboard (for BGG challenge):
                        <button on:click={copySetup}>Copy!</button>
                    </div>
                    Game seed: {$state.random.seed}
                    {#if navigator.clipboard}
                        <button on:click={async (e) => { await navigator.clipboard.writeText($state.random.seed); alert('Copied seed to clipboard!') }} >Copy to clipboard</button>
                    {/if}
                    <div>
                        Number of activations per player per turn (-1 = unlimited): <input type="number" bind:value={$prefs.numActivations} min={-1} max={20} />
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.canUndo} />Allow undo?
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.noUndoSave} />Don't save undos in autosave? (Tick to speed up saving)
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.fullDeltas} />Generate full running changelog to allow replay? (May slow game down significantly)
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.completeDismissesShips} /> Completing a mission dismisses ships at the mission?
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.scoreLocationsAtEnd} /> Score for tokens on locations at game end?
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.claimLocationsAtEnd} /> Claim secured locations at game end?
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.cancelWholeAttacks} /> Attack cancellation targets entire card text, not specific attack effects?
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.inPlayNotBeam} /> 'In play' does not include beamed cards (i.e. pre-refactor rule)?
                    </div>
                    <div>
                        Size of Glory pile (game will end when it runs out): <input type="number" bind:value={$prefs.gloryPile} on:change={updateGlory} min={0} /> <b>N.B. Changing this will reset the Glory pile, so don't do it mid-game!</b>
                    </div>
                    <div>
                       <!--<input type="checkbox" bind:checked={$prefs.stardates} /> Stardate cards? (i.e. wipe the market periodically)
                        {#if $prefs.stardates}--> 
                            <!--<div>
                                List of Glory token numbers on Stardate cards (e.g. 5x6 = 6,6,6,6,6). Only include Stardate cards that trigger a wipe (i.e. omit the final card) <input type="text" bind:value={stardateList} on:change={updateStardate} />
                            </div>-->
                        <!--{/if} -->
                    </div>
                    <div>
                        <button on:click={cleanUp}>Force clean-up (this will try and remove any duplicate cards in case of error)</button>
                    </div>
                    <div>
                        <button on:click={exportGame}>Export game as save file</button>
                        <button on:click={exportUpload}>Download game summary for stats page (to debug stats upload)</button>
                    </div>
                    <div>
                        <button on:click={toSetup}>Abandon game</button>
                        <button on:click={toScoring}>End game and score</button>
                    </div>
                </TabPanel>
                <TabPanel>
                    <h2>Interface</h2>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.forceNotTouch} /> Override touch detection (i.e. treat as not a touch device)?
                    </div>
                    <div>
                        Layout:
                        <select bind:value={$prefs.layout}>
                            <option value="auto">Auto (phone layout on phones)</option>
                            <option value="desktop">Desktop</option>
                            <option value="phone">Phone</option>
                        </select>
                        <input type="checkbox" bind:checked={$prefs.phoneHaptics} />Haptics on the phone layout?
                    </div>
                    <div>
                        Card preview scale: <input type="number" bind:value={$prefs.previewScale}>
                        <input type="checkbox" bind:checked={$prefs.showPreview} />Show card preview?
                        <input type="checkbox" bind:checked={$prefs.showHover} />Preview hovered card?
                        <!--<input type="checkbox" bind:checked={$prefs.cardBacks}/>Show card backs as images?-->
                        <input type="checkbox" bind:checked={$prefs.alwaysShowCount}/>Always show deck counts (even if 1)?
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.oldCards}/>Revert to old-style card images and icons?
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.useCardImages}/>Use images for cards?
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.showScrollbar}/>Show scrollbar for hand and staging area?
                    </div>
                    <div>
                        Card size:
                        <select bind:value={$prefs.cardScale}>
                            {#each [0.5, 0.6, 0.65, 0.7, 0.8, 0.9, 1, 1.2, 1.5, 2] as cs}
                                <option value={cs}>{cs * 100}%</option>
                            {/each}
                        </select>
                        Button size:
                        <select bind:value={$prefs.buttonScale}>
                            {#each [1, 1.2, 1.5, 1.8, 2] as bs}
                                <option value={bs}>{bs * 100}%</option>
                            {/each}
                        </select>
                        <div>
                            Margin for tokens (so they don't bump the edge of the screen): <input type="number" bind:value={$prefs.buttonMargin} min="0" max="200" step="10"/>
                        </div>
                    </div>
                    <div>
                        Action token colour (a.k.a. Completely Unnecessary Customisation #1): 
                        <select bind:value={$prefs.actionsColour}>
                            <option value={0}>Blue (default)</option>
                            <option value={160}>Red (To Boldly Go)</option>
                            <option value={270}>Green (Resistance is Futile)</option>
                        </select>
                    </div>
                    <div>
                        Length of pause for announcements to stay on screen (ms):<input type="number" min={0} bind:value={$prefs.announcementPause} />
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.showScores} />Cheat mode (show live scores)?
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.showAllCards}/>Show all cards in log (even those belonging to other players in multiplayer)?
                    </div>
                    <div>
                        Play sounds:
                        <select bind:value={$prefs.playSounds}>
                            <option value={false}>Never</option>
                            <option value="network">Only in network multiplayer</option>
                            <option value="always">Always</option>
                        </select>
                        (currently just a few, maybe there'll be more sometime...)
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.showCardScores} /> Show live scores on cards?
                    </div>
                    {#if $prefs.hasBeenWarned}
                        <div>
                            <input type="checkbox" bind:checked={$prefs.stopWarning} /> Don't display hilarious message when you try to draw a card with empty deck/discard/devs?
                        </div>
                    {/if}
                </TabPanel>
                <!---TabPanel>
                    <h2>Sounds</h2>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.playSounds} />Play sounds? (currently just a few, maybe there'll be more sometime...)
                    </div>
                </TabPanel>-->
                <TabPanel>
                    <h2>Automation</h2>
                    <!--<div>
                        <input type="checkbox" bind:checked={$prefs.showHints} />Automate card actions? (Experimental)
                    </div>-->
                    <div>
                        <input type="checkbox" bind:checked={$prefs.hideManualActions} />Hide manual actions on tooltips when card can be automatically played?
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.manualComplete} />Allow manual completion of missions?
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.allowAllActions} />Don't disable action choices even if you can't afford them?
                    </div>
                    <div>
                        Length of pause (ms) between automated effects (-1 to step through manually):<input type="number" min={-1} bind:value={$prefs.actionPause} />
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.pauseAtEnd} />Pause for confirmation at end of card? (This may give you more time to read what has been done.)
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.autoChoose} />Don't ask for confirmation when selecting cards if only 1 is possible? (a.k.a. Expert Mode)
                    </div>
                    <div>
                        <button on:click={e => $prefs.wildcardAuto = {}} disabled={Object.keys($prefs.wildcardAuto || {}).length == 0}>
                            Forget saved [[wildcard]] answers ({Object.keys($prefs.wildcardAuto || {}).length})
                        </button>
                    </div>
                </TabPanel>
                <TabPanel>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.debugLogs}/>Enable debug messages in console window? (May slow down execution)
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.useEruda}/>Enable debug logging on mobile devices (e.g. iPads or tablets)? (Requires reload to take effect)
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.showAllPrompts}/>Show all prompts, even when you are not active player? (Useful for network debugging)
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.turnSaves} /> Only save at end of turn? (May speed up performance on slower browsers)
                    </div>
                    <div>
                        <input type="checkbox" bind:checked={$prefs.performanceMeasures}/>Enable performance measurements? (Debug only; may slow down execution)
                    </div>
                    <div>
                        Backreferences ("it", "the gained card"...): 
                        <select bind:value={$prefs.useParseBindings}>
                            <option value="off">Old version (check at runtime)</option>
                            <option value="live">Experimental new version (static check)</option>
                            <option value="shadow">Transitional: use old version, but compare it with new version and flag divergence</option>  
                        </select>
                        <span style="opacity: 0.7;">(Experimental. Transitional mode is safe in normal play and in bot-vs-bot; check the console for "[bind divergence]".)</span>
                    </div>
                    {#if $prefs.useParseBindings == 'live' || $prefs.useParseBindings === true}
                        <div style="padding-left: 1.5em;">
                            Shapes resolved from bindings (turn one off to send just that shape back to the scan):
                            {#each ['prevVerb', 'it', 'num', 'prep', 'bare', 'count'] as shape}
                                <label style="margin-right: 0.75em;">
                                    <input type="checkbox" checked={!$prefs.parseBindingShapes || $prefs.parseBindingShapes[shape] !== false}
                                        on:change={e => {
                                            if(!$prefs.parseBindingShapes) $prefs.parseBindingShapes = {};
                                            $prefs.parseBindingShapes[shape] = e.target.checked;
                                            $prefs = $prefs;
                                        }}/>{shape}
                                </label>
                            {/each}
                        </div>
                    {/if}
                    <div>
                        <button disabled={!$prefs.performanceMeasures} on:click={copyPerformanceReport}>Copy performance report</button>
                        <button on:click={resetPerformanceReport}>Reset performance data</button>
                    </div>
                    {#if perfReportText}
                        <div>
                            <textarea readonly rows="8" style="width: min(80vw, 900px);">{perfReportText}</textarea>
                        </div>
                    {/if}
                    <div>
                        <button on:click={forceUndo}>Force undo, clear messages and resume play (especially for saving from accidental Burn)</button>
                    </div>
                    <div>
                        <button on:click={logAll}>Log contents of all stores to console (to see current game state in full)</button>
                        <button on:click={copyChoices}>Copy all choices for replay</button>
                        <button on:click={loadChoices}>Load all choices for replay</button>
                        <button on:click={resetAndLoadChoices}>Reset phase and rerun choices for replay</button>
                        <button disabled={!$ui.catchingUp} on:click={catchUpManually}>Mark caught up manually</button>
                    </div>
                    <div>
                        <button on:click={resolveCampaign}>Manually resolve campaign</button>
                    </div>
                </TabPanel>
            </Tabs>
            </div>
        {:else if name == 'Log'}
            <Log log={$state.log} />
        {:else if name == 'NetLog'}
            <div style="max-height: 60vh; overflow: scroll; max-width: 80vw; background-color: black; color: white;">
                <div>
                    Current time: {date.toLocaleTimeString()}
                </div>
                {#each $ui.netLog as l}
                    <div style={formatNL(l.text)} on:click={copyNL}>
                        {l.time.toLocaleTimeString()}
                        {l.text}
                        {#if l.size}<span style="color: grey;">({formatBytes(l.size)})</span>{/if}
                    </div>
                {/each}
            </div>
        {:else if name == 'Network'}
            <h2>Online multiplayer</h2>
            <div style="font-weight: bold;">
                You are playing as {$prefs.username}.
            </div>
            <div>
                This game is currently {$state.advertised ? '' :'not '}available for others to join.
                {#if $prefs.username == $state.hostUsername}
                    <button on:click={togglePublic}>Make {$state.advertised ? 'unavailable' :'available'}</button>
                {/if}
            </div>
            {#if $prefs.username == $state.hostUsername}
                <div>
                    Share your games online by default:
                    <select bind:value={$prefs.shareGames}>
                        {#each networkGamesChoices as c}
                            <option value={c}>{c}</option>
                        {/each}
                    </select>
                </div>
            {/if}
            {#if $ui.syncConflict}
                <div style="background-color: #8A5A00; color: white; padding: 1vmin; border-radius: 0.6vmin; margin: 1vmin 0;">
                    <b>Someone saved over your last move.</b>
                    <div style="font-size: 0.85em;">
                        {#if $ui.syncConflict.kind == 'diverged'}
                            The server's copy and yours are both version {$ui.syncConflict.heldVersion}
                            but differ, so two devices saved from the same starting point. Each copy is
                            missing what the other did.
                        {:else}
                            The server's copy is version {$ui.syncConflict.incomingVersion}; yours is
                            {$ui.syncConflict.heldVersion}, so theirs was written from an older copy and
                            cannot contain what you just did.
                        {/if}
                        Nothing has been changed yet.
                    </div>
                    <div style="margin-top: 0.5vmin;">
                        <button on:click={keepMyState}>Keep mine (push my version)</button>
                        <button on:click={useServerState}>Use theirs (discard my last move)</button>
                        <button on:click={clearSyncConflict}>Decide later</button>
                    </div>
                </div>
            {/if}
            {#if $ui.syncFailed}
                <div style="background-color: #A32B21; color: white; padding: 1vmin; border-radius: 0.6vmin; margin: 1vmin 0;">
                    <b>Last change was not saved to the server.</b>
                    <div style="font-size: 0.85em;">{$ui.syncFailed.what} &mdash; {$ui.syncFailed.message}</div>
                    <div style="margin-top: 0.5vmin;">
                        <button on:click={retrySync}>Retry now</button>
                        <button on:click={clearSyncFailed}>Dismiss</button>
                    </div>
                </div>
            {/if}
            <div>
                Game last synced {format(synced)}.
                <div>
                    Queue of syncs to process: {queue}
                </div>
                <div>
                    Number of syncs pushed this session: {$ui.numSyncs} (of {$ui.queuedSyncs} queued)
                </div>
                <div>
                    Force sync:
                    <div>
                        <button on:click={refreshSync}>Pull state from server</button>
                        <button on:click={e => {sendUpdate(true, false, true)}}>Push state to server</button>
                    </div>
                </div>
                <div>
                    <input type="checkbox" bind:checked={$prefs.logNetEvents} /> Log network events?
                    <button on:click={e => {$ui.showingNetLog = !$ui.showingNetLog;}}>
                        {$ui.showingNetLog ? 'Hide' : 'Show'} network log
                    </button>
                </div>
            </div>
            <div>
                {#if !$state.players.some(p => p.bot)}
                    Players in game:
                    <ul>
                        {#each $state.players as p}
                            <li>{p.captain}, played by {p.username}
                                {#if $prefs.username == $state.hostUsername}
                                    {#if p.username != $prefs.username}
                                        <button on:click={e => {bootOff(p.username)}}>Remove from game</button>  
                                    {:else if $state.dbID}
                                        <button on:click={e => {makeInvite(p.captain)}}>Create invite</button>
                                    {/if}
                                    <span style="color: yellow; transition: opacity 1s; opacity:{$ui.inviteMessages[p.captain] ? '1': '0'};">Invite has been copied to clipboard!</span>
                                {/if}
                            </li>
                        {/each}
                    </ul>
                {:else}
                    Solo game: no network players
                {/if}
            </div>
        {:else if name == 'Track'}
            <h2>Power tracks</h2>
             <Track />
        {:else if name == 'Score'}
            <ScoreAnalysis p={$state.players[$ui.viewing]} cards={allScoreableCards($state.players[$ui.viewing], true)}/>
        {/if}
    <div><button on:click={e => { $ui[`showing${name}`] = false;} }>Close</button></div>
</div>

<style>
    .modal {
		position: absolute;
		z-index: 200;
		/*left: 50%;
		top: 50%;*/
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
		padding: 3vmin;
		padding-bottom: 1vmin;
		/*transform: translate(-50%, -50%);*/
		max-height: 70vh;
        height: fit-content;
        width: fit-content;
		max-width: 90vw;
		min-width: 60vw;
		overflow: auto;
		background-color: darkblue;
        box-shadow: 0 0 5px 5px white; 
		color: white;
        white-space: normal;
        border-radius: 3vmin;
	}

    .mini {
        max-height: 20vh;
    }

    a {
        color: lightblue;
    }

    :global(svelte-tabs__list) {
        border-bottom: 2px solid white;
        margin: 0;
        padding: 0;
    }

    :global(.svelte-tabs li.svelte-tabs__selected){
        color: white;
        font-weight: bold;
        background-color: blue;
    }

    :global(.svelte-tabs li.svelte-tabs__tab){
        color: white;
        background-color: darkgrey;
    }

    .working_log {
        position: fixed;
        z-index: 300;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        padding: 2vmin;
        /* padding-bottom: 1vmin; */
        height: fit-content;
        width: fit-content;
        max-height: 20vh;
        max-width: 90vw;
        min-width: 60vw;
        overflow: auto;
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        color: white;
        background-color: rgba(2,2,2,0.5);
        border: unset;
        border-radius: 30px;
        box-shadow: 0 0 10px 5px white;
        color: white;
        display: block;
    }

    button {
		border-radius: 1vmin; 
        color: white;
		background: rgba(150,150,150,0.5);
		filter: drop-shadow(0.5vmin 0.5vmin 0.5vmin slategray);
	}

    button:disabled { 
        color: gray;
        background: rgba(0,0,0,0.5);
    }

    :global(.ok) {
        background: rgba(0,255,0,0.5);
    }

    :global(.cancel) {
        background: rgba(255,0,0,0.5);
    }

</style>
